"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var progress_modal_content_module_scss_1 = __importDefault(require("./progress-modal-content.module.scss"));

var dot_loader_component_1 = __importDefault(require("../dot-loader/dot-loader.component"));

var custom_progress_spinner_component_1 = __importDefault(require("../custom-progress-spinner/custom-progress-spinner.component"));

var ProgressModalContent = function ProgressModalContent(_ref) {
  var ProgressIcon = _ref.ProgressIcon,
      progressText = _ref.progressText,
      successText = _ref.successText,
      isPending = _ref.isPending,
      isDone = _ref.isDone;
  return react_1.default.createElement("div", {
    className: progress_modal_content_module_scss_1.default.container
  }, react_1.default.createElement("div", {
    className: progress_modal_content_module_scss_1.default.spinnerWrapper
  }, react_1.default.createElement(custom_progress_spinner_component_1.default, {
    isPending: isPending,
    isDone: isDone,
    ProgressIcon: ProgressIcon
  })), react_1.default.createElement("h2", {
    className: progress_modal_content_module_scss_1.default.text
  }, isDone ? successText : react_1.default.createElement(react_1.default.Fragment, null, progressText, react_1.default.createElement(dot_loader_component_1.default, null))));
};

exports.default = ProgressModalContent;